import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';

class Footer extends Component {
  render() {
    return (
      <Fragment>
        <div
          className='p-5'
          style={{ background: '#fff', borderTop: '1px solid #f1f1f1' }}
        >
          <p className='text-center '>
            We're committed to providing the best printers and printing
            solutions. Need help choosing the right printer?
          </p>
          <div className='text-center' style={{ marginBottom: '20px' }}>
            <Link
              to='/contact-us'
              style={{
                background: '#2563eb',
                color: '#fff',
                border: 'none',
                fontWeight: 'bold',
                padding: '12px 28px',
                borderRadius: '8px',
              }}
            >
              CONTACT US
            </Link>
          </div>
        </div>
        <div style={{ background: '#f3f3f3', borderTop: '1px solid #E7E7E7' }}>
          <div className='footer-navigation'>
            <ul style={{ margin: 0, padding: 0 }}>
              <li>
                <Link to='/track-order'> Track Your Order </Link>
              </li>
              <li>
                <Link to='/return-order'> Return Your Order </Link>
              </li>
              <li>
                <Link to='/shop-printers'> Shop Printers </Link>
              </li>
              <li>
                <Link to='/customer-support'> Customer Support </Link>
              </li>
              <li>
                <Link to='/book-appointment'> Book An Appointment </Link>
              </li>
              <li>
                <Link to='/terms-of-service'> Terms of Service </Link>
              </li>
              <li>
                <Link to='/privacy-policy'> Privacy Policy </Link>
              </li>
              <li>
                <Link to='/refund-policy'> Refund Policy </Link>
              </li>
              <li>
                <Link to='/cookie-policy'> Cookie Policy </Link>
              </li>
              <li>
                <Link to='/shipping-policy'> Shipping Policy </Link>
              </li>
            </ul>
            <p className='p-3'>
              Your trusted online printer store
              <br />© 2026 PrinterStore. All Rights Reserved.
            </p>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default Footer;
